export default function (req, res, next) {
    res.setHeader("Referrer-Policy", "strict-origin-when-cross-origin");
    res.setHeader("Strict-Transport-Security", "max-age=31536000;");
    res.setHeader("X-Frame-Options", "SAMEORIGIN");
    next();
}
